export const CREDS_CREATION_WARNING = `🚨🚨🚨
Your credentials CANNOT be recovered after they've been created. 
Be sure to store them safely!
🚨🚨🚨`;

export const INITIAL_CURSOR = "MA==";
export const END_CURSOR = "LTE=";

export const bytes32Zero = "0x0000000000000000000000000000000000000000000000000000000000000000";

export const ORDER_VERSION_MISMATCH_ERROR = "order_version_mismatch";

export const BUILDER_FEES_BPS = 10000;
